module.exports = __webpack_public_path__ + "img/parker-logo.68b4ef81.webp";